// Event names should have the following format <DOMAIN>(_FEATURE)_<ACTION>
// FEATURE can be optional
// ex: <ADDITIONAL_SERVICES>(_CONTAINS_ALCOHOL)_<TOGGLE>

export const CHANGE_ONBOARDING_WIZARD_STEP = 'CHANGE_ONBOARDING_WIZARD_STEP';
export const ADDITIONAL_SERVICES_CONTAINS_ALCOHOL_TOGGLE =
  'ADDITIONAL_SERVICES_CONTAINS_ALCOHOL_TOGGLE';
export const ADDITIONAL_SERVICES_SAVE = 'ADDITIONAL_SERVICES_SAVE';
export const ADDITIONAL_SERVICES_SAVE_FAILED = 'ADDITIONAL_SERVICES_SAVE_FAILED';

export const ORDER_CHECKOUT_STARTED = 'ORDER_CHECKOUT_STARTED';

// Carrier Account Related Events
export const CARRIER_SLIDE_MODAL_CARRIER_SELECTED = 'CARRIER_SLIDE_MODAL_CARRIER_SELECTED';
export const CARRIER_REGISTRATION_SUCCESS = 'CARRIER_REGISTRATION_SUCCESS';
export const CLICKED_FEDEX_ADVANTAGE_LINK = 'CLICKED_FEDEX_ADVANTAGE_LINK';

// Ebay CA Onboarding
export const EBAYCA_ONBOARDING_RENDERED = 'EBAYCA_ONBOARDING_DISPLAYED';
export const EBAYCA_CARRIER_SLIDE_MODAL_RENDERED = 'EBAYCA_CARRIER_SLIDE_MODAL_RENDERED';
export const EBAYCA_SKIP_BUTTON = 'EBAYCA_SKIP_BUTTON';
export const EBAYCA_PRIMARY_BUTTON = 'EBAYCA_PRIMARY_BUTTON';
export const EBAYCA_SKIP_BUTTON_VARIANT_ONE = 'EBAYCA_SKIP_BUTTON_VARIANT_ONE';
export const EBAYCA_PRIMARY_BUTTON_VARIANT_ONE = 'EBAYCA_PRIMARY_BUTTON_VARIANT_ONE';
export const EBAYCA_PRIMARY_BUTTON_VARIANT_TWO = 'EBAYCA_PRIMARY_BUTTON_VARIANT_TWO';

// Split Order Events
export const SPLIT_ORDER_MODAL_OPENED = 'SPLIT_ORDER_MODAL_OPENED';
export const SPLIT_ORDER_MODAL_CLOSED = 'SPLIT_ORDER_MODAL_CLOSED';
export const SPLIT_ORDER_MODAL_SAVE = 'SPLIT_ORDER_MODAL_SAVED';

// Branding Events
export const UPLOAD_BRAND_LOGO_SUCCESS = 'UPLOAD_BRAND_LOGO_SUCCESS';
export const SAVE_BRAND_COLOR_SUCCESS = 'SAVE_BRAND_COLOR_SUCCESS';

// UPS Master Related Events
export const UPS_MASTER_PENDING_RATE_SELECTED = 'UPS_MASTER_PENDING_RATE_SELECTED';
export const UPS_MASTER_REGISTRATION_SUCCESS = 'UPS_MASTER_REGISTRATION_SUCCESS';
export const UPS_MASTER_SHORT_FORM_DISPLAYED = 'UPS_MASTER_SHORT_FORM_SHOWN';
export const UPS_MASTER_LONG_FORM_DISPLAYED = 'UPS_MASTER_LONG_FORM_SHOWN';

// Canada Post Master Account Events
export const CANADA_POST_MASTER_PENDING_RATE_SELECTED = 'CANADA_POST_MASTER_PENDING_RATE_SELECTED';
export const CANADA_POST_MASTER_REGISTRATION_SUCCESS = 'CANADA_POST_MASTER_REGISTRATION_SUCCESS';
export const CANADA_POST_MASTER_SHORT_FORM_DISPLAYED = 'CANADA_POST_MASTER_SHORT_FORM_SHOWN';
export const CANADA_POST_MASTER_LONG_FORM_DISPLAYED = 'CANADA_POST_MASTER_LONG_FORM_SHOWN';

// DHL Express Master Account Events
export const DHL_EXPRESS_MASTER_REGISTRATION_SUCCESS = 'DHL_EXPRESS_MASTER_REGISTRATION_SUCCESS';
export const DHL_EXPRESS_MASTER_FORM_DISPLAYED = 'DHL_EXPRESS_MASTER_FORM_SHOWN';

// USPS Master Related Events
export const USPS_MASTER_RATE_SELECTED = 'USPS_MASTER_RATE_SELECTED';

// Batch Errors Modal Events
export const BATCH_ERRORS_SKIPPED = 'BATCH_ERRORS_SKIPPED';
export const BATCH_ERRORS_FIXED = 'BATCH_ERRORS_FIXED';
export const BATCH_ERRORS_SEARCH_TAB_DISPLAYED = 'BATCH_ERRORS_SEARCH_TAB_SHOWN';

// Settings Account Plan Related Events
export const SETTINGS_ACCOUNT_PLAN_PRO_ADJUST_CLICK_ADJUST_PLAN =
  'settings_account_plan_pro_adjust-click-adjustPlan';
export const SETTINGS_ACCOUNT_PLAN_STARTER_UPGRADE_CLICK_START_FREE_TRIAL =
  'settings_account_plan_starter_upgrade-click-startFreeTrial';
export const SETTINGS_ACCOUNT_PLAN_ADJUST_PLAN_NO_PAYMENT_METHOD =
  'SETTINGS_ACCOUNT_PLAN_ADJUST_PLAN_NO_PAYMENT_METHOD';
